import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKeyEvent = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("path", {
		id: "av2gsifr0a",
		d: "M16 2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-1V2h-2zm3 18H5V9h14v11z"
	}) }), /* @__PURE__ */ _jsx("g", {
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", {
			transform: "translate(-852 -718) translate(836 654) translate(16 64)",
			children: [/* @__PURE__ */ _jsx("use", {
				fill: "currentColor",
				xlinkHref: "#av2gsifr0a"
			}), /* @__PURE__ */ _jsx("path", {
				fill: "currentColor",
				d: "M10.736 16.113L8.559 13.936 7.431 14.979 10.736 18.264 17.29 11.619 16.264 10.59z"
			})]
		}) }) })
	})]
});
export default SvgKeyEvent;
